import { app } from "@microsoft/teams-js";

export type Theme = "light" | "dark" | "contrast";

function apply(theme: string | undefined): void {
  const value: Theme = theme === "dark" ? "dark" : theme === "contrast" ? "contrast" : "light";
  document.documentElement.dataset.theme = value;
}

/**
 * Initializes TeamsJS when running inside Teams and follows the client's theme. Returns the
 * user's Teams locale (e.g. `pt-br`), or undefined outside Teams.
 */
export async function initTeams(): Promise<string | undefined> {
  try {
    // Outside a host, initialize may never resolve, so the wait is capped.
    await Promise.race([
      app.initialize(),
      new Promise((_, reject) => setTimeout(() => reject(new Error("not inside Teams")), 3000)),
    ]);
    const context = await app.getContext();
    apply(context.app.theme);
    app.registerOnThemeChangeHandler(apply);
    return context.app.locale;
  } catch {
    // Outside Teams: follow the operating system theme.
    apply(window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
    return undefined;
  }
}
